import copy from 'copy-to-clipboard';
import React, { useState } from 'react';
import shareModalImage from '../../assets/images/project/share-modal.png';

interface IUserProfileModalProps {
  modalIsOpen: boolean;
  handleModalToggle?: () => void;
  project: any;
  compressedAvatarImage?: any;
}

const ProjectShareModal = ({
  modalIsOpen,
  handleModalToggle,
  project,
  compressedAvatarImage
}: IUserProfileModalProps) => {
  const getProjectPath = () => {
    const regex = /project/g;
    const currentPath = window.location.toString();
    return regex.test(window.location.toString())
      ? currentPath
      : currentPath + `project/${project.id}`;
  };

  const [copied, setCopied] = useState(false);
  const handleCopy = () => {
    copy(getProjectPath());
    setCopied(true);
  };

  const projectMedia = project.medias && project.medias[0] && project.medias[0].fileUrl;
  const modalImage = projectMedia
    ? `url(${projectMedia})`
    : `url(${shareModalImage})`;

  return (
    <div>
      <style>{`
        @keyframes copyPop {
          0% { transform: scale(1); }
          40% { transform: scale(1.08); }
          100% { transform: scale(1); }
        }
        .copy-btn-anim {
          animation: copyPop 0.3s ease-out;
        }
      `}</style>
      <div className="share-modal-card page-user-profile-modal-card" style={{ margin: '0 auto', backgroundColor: '#FFFFFF', borderRadius: '12px', overflow: 'hidden', boxShadow: '0 10px 30px rgba(0,0,0,0.1)' }}>
        <header style={{ height: '220px', width: '100%', position: 'relative' }}>
          <div
            style={{
              width: '100%',
              height: '100%',
              backgroundImage: modalImage,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat'
            }}
          />
          <div
            style={{
              position: 'absolute',
              bottom: 0,
              left: 0,
              width: '100%',
              height: '100px',
              background: 'linear-gradient(to bottom, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 100%)'
            }}
          />
        </header>

        <section className="share-modal-card-body" style={{ padding: '0 32px 40px 32px' }}>
          <div className="share-modal-card-body-content-wrapper m-b-5" style={{ flexDirection: 'column', alignItems: 'center', position: 'relative', zIndex: 2 }}>
            <h4 className="has-text-centered has-text-weight-bold" style={{ fontSize: '1.25rem', color: '#1B202B', lineHeight: '1.4', marginBottom: '8px' }}>
              {project.isPublic
                ? 'You can share on or off Matchhat'
                : 'You can share on Matchhat community'}
            </h4>
            <p className="has-text-centered" style={{ fontSize: '14px', color: '#64748B', marginBottom: '24px' }}>
              Anyone with this link will be able to view this project.
            </p>
          </div>
          <div className="share-modal-card-input-area">
            <div className="share-input-group" style={{ display: 'flex', width: '100%', border: '1px solid #E2E8F0', borderRadius: '8px', overflow: 'hidden', backgroundColor: '#F8FAFC', boxShadow: 'inset 0 2px 4px rgba(0,0,0,0.02)' }}>
              <input
                type="text"
                name="name"
                value={getProjectPath()}
                readOnly={true}
                style={{ border: 'none', outline: 'none', boxShadow: 'none', flexGrow: 1, height: '48px', padding: '0 16px', fontSize: '14px', color: '#475569', backgroundColor: 'transparent' }}
              />
              <button
                onClick={handleCopy}
                className={copied ? 'copy-btn-anim' : ''}
                style={{
                  height: '48px',
                  padding: '0 32px',
                  border: 'none',
                  background: copied ? '#4662E5' : '#5775FF',
                  color: 'white',
                  fontWeight: 600,
                  fontSize: '14px',
                  cursor: 'pointer',
                  outline: 'none',
                  transition: 'background-color 0.2s ease, transform 0.2s ease'
                }}
              >
                {copied ? 'Copied!' : 'Copy'}
              </button>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default ProjectShareModal;
